const HorizontalRuleBlock = () => {
  return (
    <div className="pt-[20px] pb-[20px] bg-white">
      <hr className="m-0 border-0 bg-[#e8e8e8] h-[1px]" />
    </div>
  )
}
export default HorizontalRuleBlock
